var map = {
	"./avatar0.png": "6973",
	"./avatar1.png": "a1a7",
	"./avatar2.png": "74e7",
	"./avatar3.png": "334b",
	"./avatar4.png": "1706",
	"./avatar5.png": "7c29"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "03ca";